import { PAGE_DESIGN_WIDTH_IN_PIXEL } from "../../constants/appConstants";

const DEFAULT_LOADING_ICON_SIZE = 60;
export const DEFAULT_LOADING_SIZE_RATIO = DEFAULT_LOADING_ICON_SIZE / PAGE_DESIGN_WIDTH_IN_PIXEL;
export const LOADING_ICON_COLOR = "#36D7B7";